import ImageTextCarousel from './image-text-carousel'
export default ImageTextCarousel
